import { connect } from 'react-redux';

import FoodProfileBasicInfo from 'apps/products/components/partials/BopFoodProfileBasicInfo';

export default connect(
  (state) => ({
    isBadgeEnabled: state.foodProfile.isBadgeEnabled,
    productsSuitability: state.foodProfile.productsSuitability,
  }))(FoodProfileBasicInfo);
